export enum SubmissionPeriodType {
  inventory = "inventory",
  customerNoticeCertification = "cnc",
}
